import { render } from "./FilterButtons.vue?vue&type=template&id=7fb047b8"
import script from "./FilterButtons.vue?vue&type=script&lang=js"
export * from "./FilterButtons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__